export function renderCalendar(containerId, activeDate = new Date(), dailyRates = {}, callbacks = {}) {
  const container = document.getElementById(containerId);
  if (!container) return;

  const { onPrevWeek, onNextWeek, onDateSelect } = callbacks;

  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const today = new Date();

  const startOfWeek = new Date(activeDate);
  startOfWeek.setDate(activeDate.getDate() - activeDate.getDay());

  const weekDays = [];
  for (let i = 0; i < 7; i++) {
    const day = new Date(startOfWeek);
    day.setDate(startOfWeek.getDate() + i);
    weekDays.push(day);
  }

  const html = `
    <div class="flex flex-col space-y-4">
      <div class="flex justify-between items-center mb-2">
        <h2 class="text-lg font-bold text-df-sapphire">
          ${activeDate.toLocaleString('default', { month: 'long', year: 'numeric' })}
        </h2>
        <div class="flex space-x-2 text-df-bluegrey">
          <button class="p-1 hover:bg-gray-200 rounded-lg transition-colors" id="prev-week" title="Previous Week">&lt;</button>
          <button class="p-1 hover:bg-gray-200 rounded-lg transition-colors" id="next-week" title="Next Week">&gt;</button>
        </div>
      </div>
      <div class="grid grid-cols-7 gap-2">
        ${days.map(d => `<div class="text-center text-[10px] uppercase tracking-wider text-df-bluegrey font-bold">${d}</div>`).join('')}
        ${weekDays.map(day => {
    const isToday = day.toDateString() === today.toDateString();
    const isActive = day.toDateString() === activeDate.toDateString();
    const dateStr = day.toISOString().split('T')[0];
    const rate = dailyRates[dateStr] || 0;

    const isPerfect = rate >= 1;
    const opacity = rate > 0 ? Math.max(0.2, rate) : 0;
    const dotColor = isPerfect ? 'bg-df-aqua shadow-[0_0_8px_rgba(151,216,196,0.6)]' : 'bg-df-bluegrey';

    return `
            <div class="flex flex-col items-center space-y-1">
              <button 
                class="calendar-day-btn w-10 h-10 flex items-center justify-center rounded-2xl text-sm font-bold transition-all duration-300
                ${isActive ? 'bg-df-sapphire text-white shadow-lg scale-110' : 'hover:bg-gray-100 text-df-bluegrey'}
                ${isToday && !isActive ? 'border-2 border-df-sapphire text-df-sapphire' : ''}"
                data-date="${dateStr}"
              >
                ${day.getDate()}
              </button>
              <div class="flex space-x-0.5 h-1.5 items-center justify-center w-full">
                <div 
                  class="w-1.5 h-1.5 rounded-full transition-all duration-500 transform
                  ${dotColor} ${isPerfect ? 'animate-pulse scale-125' : ''}"
                  style="opacity: ${opacity};"
                ></div>
              </div>
            </div>
          `;
  }).join('')}
      </div>
    </div>
  `;

  container.innerHTML = html;

  // Bind events
  const prevBtn = container.querySelector('#prev-week');
  const nextBtn = container.querySelector('#next-week');
  const dayBtns = container.querySelectorAll('.calendar-day-btn');

  if (prevBtn && onPrevWeek) prevBtn.onclick = onPrevWeek;
  if (nextBtn && onNextWeek) nextBtn.onclick = onNextWeek;

  dayBtns.forEach(btn => {
    btn.onclick = () => {
      const selectedDate = new Date(btn.dataset.date);
      if (onDateSelect) onDateSelect(selectedDate);
    };
  });
}
